export const PROPOSE_NOMINEE_API_URL = '/v1/participant/';
export const VOTE_NOMINEE_API_URL = '/v1/nominant/vote/';
export const VOTED_NOMINATIONS_API_URL = '/v1/rubrics/voted/';
export const NEWS_API_URL = '/v1/news/';
export const SUBSCRIBE_API_URL = '/v1/subscriber/activate';
export const UNSUBSCRIBE_API_URL = '/v1/subscriber/deactivate/';
export const NOMINATION_API_URL = '/v1/nominants/';
export const NOMINEES_API_URL = '/v1/rubrics';
export const WINNERS_RUBRICS_API_URL = '/v1/winners/rubrics';
export const WINNERS_NOMINEES_API_URL = '/v1/winners/nominants/';
export const PHASES_API_URL = '/v1/votingStage';
export const SUBSCRIBER_API_URL = '/v1/subscriber';
export const PARTNERS_API_URL = '/v1/partners';

export const USER_INFO_API_URL = '/v2/user';
export const SIGN_IN_API_URL = '/v2/user/signin/';
export const SIGN_OUT_API_URL = '/v2/user/signout/';
export const AUTHORIZATION_LINKS_API_URL = '/v2/links/authorization';

export const HOW_IT_WAS_URL = '/v2/how-it-was';

export const ABOUT_TEXT_API_URL = '/v1/page/?name=about';
export const ABOUT_MAIN_TOP_TEXT_API_URL = '/v1/page/?name=aboutMainTop';
export const ABOUT_MAIN_BOTTOM_TEXT_API_URL = '/v1/page/?name=aboutMainBottom';
export const ABOUT_TITLE_API_URL = '/v1/page/?name=aboutTitle'
export const AFTER_SUBMIT_TEXT_API_URL = '/v1/page/?name=afterSubmitForm';
export const DOCUMENTS_TEXT_API_URL = '/v1/page/?name=documents';
export const PARTNERS_TEXT_API_URL = '/v1/page/?name=partnersText';
export const MEMBERS_TEXT_API_URL = '/v1/page/?name=members';
export const MEMBERS_TITLE_API_URL = '/v1/page/?name=membersTitle'
export const ACTION_BUTTON_TEXT_API_URL = '/v1/page/?name=buttonName';
export const SHORT_LIST_MESSAGE_API_URL = '/v1/page/?name=shortListMessage';
export const BEFORE_AUTH_TEXT_API_URL = '/v1/page/?name=beforeAuthText';
export const VOTES_TITLE_API_URL = '/v1/page/?name=votesTitle'
export const DOCUMENTS_TITLE_API_URL = '/v1/page/?name=documentsTitle'
export const PARTNERS_TITLE_API_URL = '/v1/page/?name=partnersTitle'
export const NEWS_TITLE_API_URL = '/v1/page/?name=newsTitle'
export const LIVE_TITLE_API_URL = '/v1/page/?name=liveTitle'
export const LIVE_HEADER_API_URL= '/v1/page/?name=liveHeader';
export const LIVE_TOP_TEXT_API_URL = '/v1/page/?name=liveTopText';
export const LIVE_STREAM_API_URL= '/v1/page/?name=liveStream';
export const IMAGES_API_URL = '/v2/images';

export const HEADER_MENU_API_URL = '/v2/header';
export const FOOTER_MENU_API_URL = '/v2/footer';

export const ANNOUNCEMENT_RESULT_TEXT_API_URL = '/v1/page/?name=announcementResultsText'




// WEBPACK FOOTER //
// ./src/constants/urls.js